module.exports = __webpack_public_path__ + "img/notion-round.374a83ff.svg";